<div class="wz">
  <header class="wz__header">
    <a class="wz__brand" routerLink="/" aria-label="Zur Startseite">
      <span class="wz__brand-mark cr-display">Craftly</span>
    </a>
    <span class="wz__chip">Geführte Anfrage</span>
    <div class="wz__spacer"></div>
    @if (store.trade()) {
      <span class="wz__counter cr-mono">
        {{ progress().step + 1 < 10 ? '0' + (progress().step + 1) : (progress().step + 1) }}
        <span class="wz__counter-sep">/</span>
        {{ progress().total < 10 ? '0' + progress().total : progress().total }}
      </span>
    }
    <button type="button" class="wz__close" (click)="cancel()" aria-label="Abbrechen">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M6 6l12 12M18 6 6 18"/>
      </svg>
    </button>
  </header>

  @if (store.trade()) {
    <div class="wz__progress">
      <div class="wz__progress-rail">
        <div class="wz__progress-fill"
             [style.width.%]="progress().total > 0 ? ((progress().step + 1) / progress().total) * 100 : 0">
        </div>
      </div>
    </div>
  }

  <div class="wz__body">
    <div class="wz__inner" [class.wz__inner--wide]="currentNode()?.type === 'summary_and_extras'">
      @if (loading()) {
        <div class="wz__center wz__center--loading">
          <span class="wz__spinner" aria-hidden="true"></span>
          <span>Anfrage-Konfiguration wird geladen …</span>
        </div>
      } @else if (loadError()) {
        <div class="wz__center wz__center--error">
          <p>{{ loadError() }}</p>
          <button type="button" class="wz__retry" (click)="cancel()">Zurück zur Startseite</button>
        </div>
      } @else if (tradePicker()) {
        <app-trade-picker [trades]="tradePicker()!" (picked)="pickTrade($event)" />
      } @else if (rendererComponent()) {
        <ng-container *ngComponentOutlet="rendererComponent()!; inputs: rendererInputs()" />
      }
    </div>
  </div>

  @if (store.trade() && !tradePicker()) {
    <footer class="wz__footer">
      <button type="button" class="wz__back" (click)="back()" [class.wz__back--hidden]="!store.canGoBack()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M19 12H5M11 5l-7 7 7 7"/>
        </svg>
        Zurück
      </button>
      <div class="wz__footer-trust">
        <span><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-11"/></svg> Kostenlos</span>
        <span><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5 9-11"/></svg> Unverbindlich</span>
        <span><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2 4 5v7c0 5 4 9 8 10 4-1 8-5 8-10V5l-8-3Z"/><path d="m9 12 2 2 4-4"/></svg> DSGVO</span>
      </div>
    </footer>
  }
</div>
